import React, {useState} from 'react'
import AxiosControl from '../../components/axios/AxiosControl'
import { useNavigate, useParams  } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import Swal from 'sweetalert2'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'

export default function ResetPassword() {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const Axios = AxiosControl()

    const [isLoading, setIsLoading] = useState(false)
    const [isError, setIsError] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [showPasswordOne, setShowPasswordOne] = useState(false)
    const [showPasswordTwo, setShowPasswordTwo] = useState(false)
    const [isCorrect, setIsCorrect] = useState(false)

    const { id } = useParams()
    const { tokenresetpassword } = useParams()

    const handlePasswordVisibilityOne = () => {
        setShowPasswordOne(!showPasswordOne)
    }

    const handlePasswordVisibilityTwo = () => {
        setShowPasswordTwo(!showPasswordTwo)
    }

    /**
     * Captura el submit del formulario y cambia la clave de la cuenta
     * @param {*} e 
     */
    const handleSubmit = async(e) => {
        e.preventDefault()

        if (!isCorrect) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('passwordreset.passwordsdoesnotmatch')
            })
            return
        }

        if (!password.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,20}$/g)) {
            Swal.fire({
                showConfirmButton: true,
                icon: 'warning',
                text: t('users.passwordsnotvalid')
            })
            return
        }

        const clientPassword = {password}
           
        setIsLoading(true)

        await Axios.put(process.env.REACT_APP_DB_ADDRESS + '/api/forgot/resetpassword?id=' + id + '&token=' + tokenresetpassword, clientPassword, {
            where: {
                id: id,
                tokenresetpassword: tokenresetpassword
            }
        })
        .then((res) => {            
            setIsLoading(false)

            // Mostramos la notificación
            Swal.fire({
                showConfirmButton: true,
                icon: 'success',
                text: t('passwordreset.passwordreset')
            })

            // Redirigimos a la raíz
            navigate('/')

        }).catch((err) => {
            setIsLoading(false)
            Swal.fire({
                showConfirmButton: true,
                icon: 'error',
                text:  t('passwordreset.error')
            })
        })
    }

    const checkValidation = (isPassVer, e) => {
        const confirmPass = e.target.value

        if (isPassVer) {
            setConfirmPassword(confirmPass)
        } else {
            setPassword(confirmPass)
        }

        if (password !== confirmPass) {
            setIsCorrect(false)
            setIsError(t('passwordreset.passwordsdoesnotmatch'))
        } else {
            setIsCorrect(true)
            setIsError("")
        }
    }

    return (
        <Container className="login vh-100 d-flex align-items-center px-4">
            <Row className="px-4">
                <Container className="text-center text-white">
                    <Row className="mb-5">
                        <Col>
                            <img
                                src="/images/logotipo-rumiantec-cabecera.png"
                                alt="Logotipo Rumiantec"
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <Form onSubmit={handleSubmit}>
                                <Row className='p-0 m-0 '>
                                    <Col xs={12}>
                                        <h1>{t('passwordreset.question')}</h1>
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col className='sd-passwordview'>
                                        <Form.Label htmlFor='password'>{t('passwordreset.new_password')} ({t('global.mandatory')})</Form.Label>
                                        <Form.Control
                                            className="sd-input"
                                            type={showPasswordOne ? 'text' : 'password'}
                                            name='password' 
                                            value={password || ''}
                                            onChange={(e) => checkValidation(false, e)}
                                            required
                                        />
                                        <img
                                            className="sd-imageneye"
                                            src={showPasswordOne ? "/images/eyeclose.svg" : "/images/eyeopen.svg"}
                                            alt="eyes"
                                            width={15}
                                            onClick={handlePasswordVisibilityOne}
                                        />
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col className='text-start'>
                                        <span className='ps-1'>{t('users.passwordneed1')}</span><br/>
                                        <span className='password-list'>
                                            <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed2')}</span>
                                            <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed3')}</span>
                                            <span className='fs-12 fw-400'><b>·</b> {t('users.passwordneed4')}</span>
                                        </span>
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col className='sd-passwordview'>
                                        <Form.Label htmlFor='confirm_password'>{t('passwordreset.confirm_password')} ({t('global.mandatory')})</Form.Label>
                                        <Form.Control
                                            className="sd-input"
                                            type={showPasswordTwo ? 'text' : 'password'}
                                            name='confirm_password'
                                            value={confirmPassword || ''}
                                            onChange={(e) => checkValidation(true, e)}
                                            required
                                        />
                                        <img
                                            className="sd-imageneye"
                                            src={showPasswordTwo ? "/images/eyeclose.svg" : "/images/eyeopen.svg"}
                                            alt="eyes"
                                            width={15}
                                            onClick={handlePasswordVisibilityTwo}
                                        />
                                    </Col>
                                </Row>
                                {isError !== '' && (
                                    <Row className="my-3">
                                        <Col>
                                            <div className="text-color2">* {isError} *</div>
                                        </Col>
                                    </Row>
                                )}
                                <Row className="my-3">
                                    <Col>
                                        <Button type="submit" variant="primary" className="w-100 my-2">
                                            {isLoading
                                                ? <span className="indicator-label">
                                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                                </span>
                                                : <span className="indicator-label">{t('passwordreset.submit')}</span>
                                            }
                                        </Button>                                           
                                    </Col>
                                </Row>
                                <Row className="my-3">
                                    <Col>
                                        <Link to={`/${t("url.auth.login")}`} className='btn btn-secondary w-100 my-2'>
                                                {t('global.return')}
                                        </Link>
                                    </Col>
                                </Row>
                            </Form>
                        </Col>
                    </Row>
                </Container>
            </Row>
        </Container>
    )
}